export default __webpack_public_path__ + "static/media/introBottom.f1e9b155.svg";